<ng-container *ngIf="encumbrance">
	<div class="w-full">
		<div class="flex justify-between items-center my-4">
			<h5 class="mb-0 font-bold">
				{{ getEncumbranceTitle(encumbrance.type) }}
			</h5>
			<app-checkbox
				type="clear"
				class="text-sm"
				[ngModel]="encumbrance?.obtainingDischargeStatement"
				(ngModelChange)="setObtainingDischargeStatement($event)"
				>Obtaining
				{{
					encumbrance?.action === actionTypes.REMAIN
						? 'information'
						: 'discharge'
				}}
				statement</app-checkbox
			>
		</div>
		<app-input
			[startIcon]="ICON.DOLLAR"
			*ngIf="encumbrance?.action === actionTypes.REMAIN"
			class="mb-2"
			type="cents"
			label="Outstanding amount"
			[ngModel]="encumbrance?.outstandingAmount"
			(debounce)="setOutstandingAmount($event)"
		></app-input>
		<div class="grid grid-cols-2 gap-4">
			<app-input
				label="Loan number"
				[ngClass]="{
					'col-span-2': encumbrance?.action !== actionTypes.REMAIN,
					'col-span-1': encumbrance?.action === actionTypes.REMAIN,
				}"
				[ngModel]="encumbrance?.loanNumber"
				(debounce)="setLoanNumber($event)"
			></app-input>
			<app-dropdown
				class="col-span-1"
				*ngIf="encumbrance?.action === actionTypes.REMAIN"
				label="Priority after closing"
				[itemGroups]="[{ items: encumbrancePriorities }]"
				(onSelect)="onSelectPriorityAfterClosing($event)"
				[ngModel]="selectedPriorityAfterClosingName"
			></app-dropdown>
		</div>
		<div class="mt-2">
			<atomic-message-bar
				type="warn"
				[shadow]="false"
				*ngIf="
					encumbrance?.action === actionTypes.REMAIN && showPriorityWarning
				"
			>
				<p>
					A
					<span class="cursor-pointer underline" (click)="editPriority()">{{
						showPriorityWarning
					}}</span>
					with {{ selectedPriorityAfterClosingName }} priority already exists.
				</p>
			</atomic-message-bar>
		</div>

		<div class="flex mt-2 gap-4">
			<app-input
				label="Registration number"
				[ngModel]="encumbrance?.registrationNumber"
				(debounce)="setRegNumber($event)"
			></app-input>
			<app-date-picker
				label="Registration date"
				[ngModel]="encumbrance?.registrationDate"
				(ngModelChange)="setRegDate($event)"
			></app-date-picker>
		</div>

		<div class="flex mt-2 gap-4 w-1/2">
			<app-date-picker
				label="Maturity date"
				[ngModel]="encumbrance?.maturityDate"
				(ngModelChange)="setMaturityDate($event)"
				class="mr-2"
			></app-date-picker>
		</div>

		<div class="w-9/12 mt-4" *ngIf="encumbrance?.action === actionTypes.REMAIN">
			<app-checkbox
				[ngModel]="encumbrance?.postponeMortgage"
				(ngModelChange)="setPostponeMortgage($event)"
				>Postpone mortgage</app-checkbox
			>
		</div>
		<div class="flex flex-col" *ngIf="encumbrance?.postponeMortgage">
			<app-checkbox
				*ngIf="encumbrance?.action === actionTypes.REMAIN"
				class="w-full mt-4"
				[ngModel]="encumbrance?.payPostponomentFeeFromTrustAccount"
				(ngModelChange)="setPayPostponomentFeeFromTrustAccount($event)"
				type="clear"
			>
				Pay postponement fee from Trust account
			</app-checkbox>
			<app-input
				[startIcon]="ICON.DOLLAR"
				*ngIf="encumbrance?.action === actionTypes.REMAIN"
				label="Postponement fee"
				class="mr-2 mt-4 w-1/2"
				[ngModel]="encumbrance?.postponementFee"
				type="cents"
				(debounce)="setPostponementFee($event)"
			></app-input>
		</div>
		<div
			*ngIf="encumbrance?.action === actionTypes.ASSUME"
			class="w-1/2 pr-2 mt-3"
		>
			<app-input
				type="cents"
				label="Principal amount"
				[startIcon]="ICON.DOLLAR"
				[ngModel]="encumbrance?.paymentCalc?.principalAmount"
				(debounce)="setPrincipalAmount($event)"
			></app-input>
		</div>
		<div *ngIf="encumbrance?.action !== actionTypes.ASSUME">
			<div class="flex items-center mt-10">
				<span class="font-bold">Related instruments</span>
				<app-button
					size="small"
					[icon]="ICON.ADD"
					class="ml-5"
					(click)="addRelatedInstrument()"
					>Add related instrument</app-button
				>
			</div>
			<app-container
				*ngFor="
					let relatedInstrument of encumbrance?.relatedInstruments | keyvalue;
					trackBy: trackByKey
				"
				class="mt-3"
				type="dark"
			>
				<div class="flex flex-col">
					<div class="flex justify-end">
						<app-button
							[icon]="ICON.DELETE"
							btn="tertiary"
							(click)="delete(relatedInstrument?.key)"
							class="ml-5"
						></app-button>
					</div>
					<app-input
						label="Instrument type"
						[ngModel]="relatedInstrument?.value?.instrumentType"
						(debounce)="setInstrumentType(relatedInstrument?.key, $event)"
					></app-input>
					<div class="flex mt-2">
						<app-input
							label="Registration number"
							[ngModel]="relatedInstrument?.value?.registrationNumber"
							(debounce)="
								setInstrumentRegNumber(relatedInstrument?.key, $event)
							"
							class="flex-1 mr-2"
						></app-input>
						<app-date-picker
							label="Registration date"
							[ngModel]="relatedInstrument?.value?.registrationDate"
							(ngModelChange)="
								setInstrumentRegDate(relatedInstrument?.key, $event)
							"
							class="ml-2 flex-1"
						></app-date-picker>
					</div>
				</div>
			</app-container>
		</div>
	</div>
</ng-container>
